import { DispatchState, Guard } from "./types";

export function getDefaultState(): DispatchState {
    return {
        DispatchedGuards: Array<Guard>(),
        Guards: [],
        GuardTypes: [],
        GuardsForFilter: [],
        PatrolZones: [],
        EventGuards: Array<Guard>(),
        GuardsCallsignListFilter: "",
        GuardsPatrolZoneListFilter: -1,
        AlarmFilters: [],
        BulkEditDialogOpen: false,
        BulkUploadDialogOpen: false,
        EventLocation: ""
    }
}